module.exports = [{
      plugin: require('/zeit/2316462f/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-P4V7K6M","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}}},
    },{
      plugin: require('/zeit/2316462f/packages/landing-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
